import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgSmGoogleMonochrome = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.548 12.005c-1.171-1.092-2.655-1.65-4.311-1.65-2.932 0-5.419 1.933-6.31 4.54v.003a6.51 6.51 0 0 0-.35 2.105c0 .73.123 1.437.35 2.101.891 2.608 3.378 4.542 6.31 4.542 1.517 0 2.814-.39 3.822-1.055v.001c1.215-.801 2.008-2.003 2.255-3.412l-6.08-.002V14.94H27.79c.137.74.21 1.509.21 2.313 0 3.345-1.21 6.175-3.324 8.09h-.003C22.818 27.025 20.27 28 17.237 28c-4.39 0-8.19-2.465-10.04-6.057l-.002.001A10.778 10.778 0 0 1 6 17.003c0-1.778.43-3.455 1.195-4.941h.002l-.002-.002C9.045 8.466 12.847 6 17.236 6c3.032 0 5.57 1.09 7.519 2.867l-3.207 3.138Z",
  fill: "#000"
})));

export { SvgSmGoogleMonochrome as default };
